import templateUrl from 'emun.order/ticket-list-table.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

let component = {
    bindings: {
    },
    require: {
        container: '^ticketContainer',
        list: '^ticketList'
    },
    controller() {
        basicController(this);
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default component;